var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9446 13.2946C39.7344 12.5146 39.3236 11.8033 38.753 11.2314C38.1824 10.6596 37.472 10.2471 36.6925 10.0351C33.8021 9.24145 22.2388 9.22853 22.2388 9.22853C22.2388 9.22853 10.6773 9.21561 7.78504 9.97419C7.00601 10.196 6.29707 10.6142 5.72628 11.1889C5.15548 11.7636 4.742 12.4754 4.52552 13.2559C3.76325 16.1462 3.75586 22.1411 3.75586 22.1411C3.75586 22.1411 3.74848 28.1655 4.50522 31.0263C4.92973 32.6081 6.17558 33.8576 7.7592 34.284C10.6791 35.0777 22.2111 35.0906 22.2111 35.0906C22.2111 35.0906 33.7744 35.1035 36.6648 34.3468C37.4446 34.1351 38.1557 33.7236 38.7277 33.1529C39.2997 32.5822 39.7128 31.8721 39.9262 31.0928C40.6903 28.2042 40.6958 22.2112 40.6958 22.2112C40.6958 22.2112 40.7328 16.185 39.9446 13.2946ZM18.54 27.6948L18.5492 16.6206L28.1598 22.1669L18.54 27.6948Z",
    fill: "#221511"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.3dc965141c250b1c67af8507886ac6d7.svg";
export { ForwardRef as ReactComponent };